import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {UserPermissionsPage} from "./-page/user-permissions.page";
import {UserPermissionsPending} from "./-page/user-permissions.pending";

export const Route = createFileRoute("/_app/user-management/users/$userId/permissions/")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  pendingComponent: UserPermissionsPending,
});

function RouteComponent() {
  const {userId} = Route.useParams();

  return <UserPermissionsPage key={userId} userId={userId} />;
}
